module.exports = __webpack_public_path__ + "img/clip.59516e48.svg";